// extracted by mini-css-extract-plugin
export var herocopy = "home-module--herocopy--ryxyA";
export var heading = "home-module--heading--3Lk88";
export var subtitle = "home-module--subtitle--14OhR";
export var partners = "home-module--partners--100r7";
export var partner = "home-module--partner--1QlYm";
export var what = "home-module--what--3WLix";
export var greenheading = "home-module--greenheading--3ia5X";
export var rectangle = "home-module--rectangle--197Zo";
export var pointCover = "home-module--pointCover--3D7ZQ";
export var point = "home-module--point--1XHQ6";
export var whywrap = "home-module--whywrap--2mRGt";
export var why = "home-module--why--arn5K";
export var reason = "home-module--reason--3I0pe";
export var links = "home-module--links--3OXJQ";
export var follow = "home-module--follow--g_Q08";
export var socialswrap = "home-module--socialswrap--1DVRi";
export var socials = "home-module--socials--17D-V";